import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseConsultation } from "./UseConsultation";
import CustomPagination from "../../components/CustomPagination";
import useBreakpoints from "../../hooks/useBreakpoints";
import AssignmentIcon from "@mui/icons-material/Assignment";
import OrderItems from "./OrderItems";

export default function ConsultationOrders(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetOrderById } = UseConsultation();
  const { isSmall } = useBreakpoints();
  const [state, setState] = useState([]);
  const [hasMore, setHasMore] = useState();
  const [openItems, setOpenItems] = useState({ show: false, items: [] });
  const [pageState, setPageState] = useState({
    page: 1,
  });

  useEffect(() => {
    if (props.consultantID) {
      setProgress(true);
      GetOrderById(props.consultantID, pageState.page, (details) => {
        if (details.length) {
          setHasMore(true);
        } else {
          setHasMore(false);
        }
        let fullList = [...state, ...details];
        details = fullList;
        setState(details);
      });
    }
  }, [pageState, props.consultantID]);

  function newFunc(pags) {
    setPageState((old) => ({ page: pageState.page + 1 }));
  }

  const columns = [
    {
      field: "rowNO",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "id",
      width: 100,
      align: "center",
      headerName: "سفارش",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "shamsiLogdate",
      headerName: "تاریخ",
      width: 150,
      align: "center",
      headerAlign: "center",
      sortable: false,
    },

    {
      field: "city",
      headerName: "شهر",
      width: 120,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.city}
          </Typography>
        );
      },
    },

    {
      field: "state",
      headerName: "وضعیت",
      width: 140,
      align: "center",
      headerAlign: "center",
      sortable: false,
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{
              whiteSpace: "normal",
            }}
          >
            {cellValues.row.state}
          </Typography>
        );
      },
    },
    {
      field: "جزییات",
      sortable: false,
      width: 70,
      align: "center",
      headerAlign: "center",
      headerName: "جزییات",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="detail">
            <IconButton
              sx={{ ml: 1 }}
              onClick={() => {
                setOpenItems({ show: true, items: cellValues.row.items });
              }}
            >
              <AssignmentIcon fontSize="small" sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      onClose={() => {
        props.setShowOrder(false);
      }}
      open={props.showOrder}
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: 2,
          alignItems: "center",
        }}
      >
        <Typography sx={{ width: 1, textAlign: "left" }}>
          سفارشات کاربر
        </Typography>
        <Box sx={{ width: 1, height: "20rem" }}>
          <DataGrid
            className="ltr-grid"
            localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
            columns={columns}
            rows={state ? state : []}
            page={pageState.page - 1}
            pageSize={20}
            Pagination
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...pageState, page: newPage + 1 }));
            }}
            rowCount={state && state.length ? state.length : 1}
            disableColumnMenu
            hideFooterSelectedRowCount
            components={{
              Pagination: CustomPagination,
            }}
            componentsProps={{
              pagination: {
                showMoreConsultant: true,
                hasMore: hasMore,
                nofab: true,
                noPage: true,
                isLtr: true,
                newFunc: newFunc,
                rowCount: state && state.length ? state.length : "",
              },
            }}
            initialState={{
              sorting: {
                sortModel: [
                  {
                    field: "rowNO",
                    sort: "asc",
                  },
                ],
              },
            }}
          />
        </Box>

        <Button
          variant="outlined"
          onClick={() => {
            props.setShowOrder(false);
          }}
        >
          بستن
        </Button>
      </DialogContent>
      <Dialog
        fullWidth
        maxWidth="md"
        onClose={() => {
          setOpenItems({ show: false, items: [] });
        }}
        open={openItems.show}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Typography sx={{ width: 1, textAlign: "left" }}>
            جزییات سفارش
          </Typography>
          <Box sx={{ width: 1, height: "20rem" }}>
            <OrderItems
              OrderItems={true}
              rows={openItems.items ? openItems.items : []}
            />
          </Box>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenItems({ show: false, items: [] });
            }}
          >
            بازگشت
          </Button>
        </DialogContent>
      </Dialog>
    </Dialog>
  );
}
